export const country = "EE"
export const instagramLink = "https://instagram.com/raamatuvahetus"
export const facebookLink = "https://www.facebook.com/raamatuvahetus.ee"
export const tiktokLink = "https://www.tiktok.com/@raamatuvahetus"
export const copyright = "2025 O\u00DC Bookswap International"
export const phoneCode = "+372"
export const logoImage = "/assets/images/raamatuvahetus-logo.svg"
export const smallLogoImage = "/assets/images/raamatuvahetus-logo-mobile.svg"
export const desktopCoverImage = "/assets/images/bookswap-ee-banner.jpg"
export const mobileCoverImage = "/assets/images/bookswap-ee-banner-mobile.jpg"
export const promoVideoLink = "none"
export const showBannerOnSendOutPage = false
export const showLabelDownloadLink = true
export const showGivePoints = false
export const iosAppLink =
  "https://apps.apple.com/ee/app/raamatuvahetus/id6504609475"
export const androidAppLink =
  "https://play.google.com/store/apps/details?id=ee.raamatuvahetus.webapp"
export const mobileAppName = "Raamatuvahetuse mobiili\u00E4pp"
export const mobileAppTagline = "Vaheta raamatuid veelgi mugavamalt!"
